@if (result == null) {
  <button class="btn btn-link me-3" (click)="dismiss.emit()">{{ 'button.cancel' | translate }}</button>
  <button
    class="btn"
    [class]="'btn-' + variant"
    [disabled]="disabled || invalid || pending"
    (click)="submit.emit()"
  >
    @if (pending) {
      <i class="far fa-circle-notch fa-spin me-1"></i>
    }
    <span>{{ (pending ? 'bulkActions.submitting' : actionLabel) | portalTranslate }}</span>
  </button>
} @else {
  <ng-template [ngTemplateOutlet]="result?.allSucceeded ? successFooter : retryFooter"></ng-template>
}

<ng-template #successFooter>
  <button class="btn btn-link" (click)="close.emit()">{{ 'button.close' | portalTranslate }}</button>
</ng-template>

<ng-template #retryFooter>
  <button class="btn btn-link me-3" (click)="dismiss.emit()">{{ 'button.close' | portalTranslate }}</button>

  <button
    class="btn"
    [class]="'btn-' + variant"
    [disabled]="disabled || invalid || pending"
    (click)="submit.emit()"
  >
    @if (pending) {
      <i class="far fa-circle-notch fa-spin me-1"></i>
    }
    <span>{{ (pending ? 'bulkActions.submitting' : 'bulkActions.retry') | portalTranslate }}</span>
  </button>
</ng-template>
